// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3zJFW","content":"styles_content__1snlN","selectAll":"styles_selectAll__16Zcx"};